module.exports = __webpack_public_path__ + "static/media/chevron-left-border.3051995e.svg";